import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  imports: [NgClass, MatIconModule, MatButtonModule],
  selector: 'app-dashboard-section-header',
  templateUrl: './dashboard-section-header.component.html',
  styleUrls: ['./dashboard-section-header.component.scss'],
})
export class DashboardSectionHeaderComponent {
  @Input()
  hideAddButton = false;

  @Input()
  hideCollapseButton = false;

  @Input()
  showRefreshButton = false;

  @Input()
  refreshing = false;

  @Input()
  headerText!: string;

  /** When true, section body (projected content) is hidden. */
  collapsed = false;

  @Output()
  addNew: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  refresh: EventEmitter<void> = new EventEmitter<void>();

  add(): void {
    this.addNew.emit();
  }

  onRefresh(): void {
    this.refresh.emit();
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }
}
